import { getRTL } from "@fluentui/utilities/lib/rtl";

/**
 * Look up whether language (locale) used to localize UX content for the user is RTL-based
 *
 * This is agnostic of backing storage or config, which can vary by runtime context (e.g. OWA, OPX, etc)
 */
export function isCurrentCultureRightToLeft(): boolean {
    return getRTL();
}
